import React from 'react';

import cx from 'classnames';
import { isNil } from 'ramda';

import Icon from 'components/shared/Icon';
import DragHandleIcon from 'components/shared/Icon/icons/DragHandleIcon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import { LOREM_IPSUM_TEXT, SYMBOLS_LIMIT } from 'constants/texts';
import { TAddBlockHandlerFn } from 'detailsv2/LandingV2/Page/RightSide/Block/types';
import AddNewContent from 'detailsv2/LandingV2/Page/RightSide/blocks/AddNewContent';
import { useAccordionScroll } from 'hooks/useAccordionScroll';
import { confirmAlert } from 'utils/alert';
import { isTextBlockDefined } from 'utils/blocksHelpers/isTextBlockDefined';
import { isNotDefined } from 'utils/ramda';

import Title from '../Title';
import { ChildrenBlocks } from './ChildrenBlocks';
import s from './index.module.css';
import * as types from './types';
import { useSpoiler } from './useSpoiler';

function Spoiler(props: types.ISpoilerProps) {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const {
    isActive,
    onToggle,
    onDelete,
    data,
    readOnly = false,
    onAddBlock,
    onUpdateBlock,
    onDeleteBlock,
    htmlId,
  } = props;

  const {
    attributes,
    setNodeRef,
    styleDndButton,
    handleChangeTitle,
    handleChangeBody,
    handleDeleteBody,
    handleOnTouchStart,
    handleOnMouseDown,
    handleOnKeyDown,
  } = useSpoiler(props);

  useAccordionScroll({ isActive, htmlId, contentRef, proposalType: 'v1' });

  const onAddFirstBlock = onAddBlock?.(0, 'before') as TAddBlockHandlerFn;

  if (!data) return null;

  const filteredChildren = data?.children?.filter((block) => !block?._destroy);
  const isChildrenEmpty = isNotDefined(filteredChildren);
  const hasContent = isTextBlockDefined(data?.body) || !isChildrenEmpty;
  const toggleableSpoiler = !readOnly || isTextBlockDefined(data.body) || !isChildrenEmpty;

  return (
    // FIXME: fix any
    <div className={cx(s.item, 'custom-accordion-item')} ref={setNodeRef} style={styleDndButton as any}>
      {!readOnly && (
        <button
          {...attributes}
          // FIXME: fix any
          onKeyDown={handleOnKeyDown as any}
          onMouseDown={handleOnMouseDown as any}
          onTouchStart={handleOnTouchStart as any}
          type="button"
          className={s.dndButton}
        >
          <Icon component={DragHandleIcon} />
        </button>
      )}
      <div className={cx(s.head, 'custom-accordion-item-head')} onClick={onToggle}>
        {/*@ts-ignore*/}
        <Title value={data.title} onChange={handleChangeTitle} readOnly={readOnly} />
        <div className={cx(s.right, 'custom-accordion-item-right')}>
          {toggleableSpoiler && (
            <div className={cx(s.faqIcon, 'custom-accordion-item-faqIcon')}>{isActive ? '-' : '+'}</div>
          )}

          {!readOnly && (
            <Icon
              component={Trash2}
              className={cx(s.removeIcon, 'custom-accordion-item-remove')}
              width="20px"
              height="16px"
              onClick={(e) => {
                e.stopPropagation();
                confirmAlert({
                  confirmButtonText: 'Delete',
                  onConfirm: async () => {
                    await onDelete();
                  },
                  title: 'Are you sure you want to delete this Info?',
                });
              }}
            />
          )}
        </div>
      </div>

      {toggleableSpoiler && (
        <div
          className={cx(s.accordionItemContent, 'custom-accordion-item-content')}
          style={{ display: isActive ? 'block' : 'none' }}
          ref={contentRef}
          data-block
          id={htmlId}
        >
          <div className={s.bodyContainer}>
            {data?.body && isNil(data?.children) && (
              <Wysiwyg
                data={data.body}
                onChange={handleChangeBody}
                onDelete={handleDeleteBody}
                placeholder={LOREM_IPSUM_TEXT}
                isReadOnly={readOnly}
                limit={SYMBOLS_LIMIT}
                hideLimit
              />
            )}

            {!readOnly && !isNil(data?.children) && (
              <AddNewContent
                className={cx(s.plusVisible, s.plusButtonContainer)}
                onAdd={onAddFirstBlock}
                isVisible={!hasContent}
                isInsideAccordion
              />
            )}
          </div>

          {data?.children && (
            <ChildrenBlocks
              blocks={data?.children}
              onAddBlock={onAddBlock}
              onUpdateBlock={onUpdateBlock}
              onDeleteBlock={onDeleteBlock}
              readOnly={readOnly}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default Spoiler;
